import { createFileRoute } from '@tanstack/react-router';
import ResetPassword from '@/pages/ResetPassword';

export interface ResetPasswordSearch {
  token?: string;
}

export const Route = createFileRoute('/_public/reset-password')({
  validateSearch: (raw: Record<string, unknown>): ResetPasswordSearch => ({
    token: (raw.token as string) ?? undefined,
  }),
  component: ResetPassword,
});
